import { GlobalNavbarService } from '../../../global-navbar.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-navbar-discover',
  templateUrl: './mobile-navbar-discover.component.html'
})
export class MobileNavbarDiscoverComponent implements OnInit {

  constructor(public gns: GlobalNavbarService) { }

  ngOnInit() {
  }

}
